// Navigacijos programa — vartotojo pasirinkta pagrindinė (Google Maps / Waze / Apple Maps).
// Įsimenam localStorage; „Kelias iki čia" veda tiesiai į ją. Keisti — palaikius mygtuką.

const RAKTAS = 'navigacija'

export const NAVIGACIJOS = [
  { id: 'google', pavadinimas: 'Google Maps', ikona: 'map' },
  { id: 'waze', pavadinimas: 'Waze', ikona: 'waze' },
  { id: 'apple', pavadinimas: 'Apple Maps', ikona: 'apple' },
]

export function getNavigacija() {
  try {
    const v = localStorage.getItem(RAKTAS)
    return NAVIGACIJOS.some(n => n.id === v) ? v : null
  } catch {
    return null
  }
}

export function setNavigacija(id) {
  try { localStorage.setItem(RAKTAS, id) } catch {}
}

// Ar įrenginys iOS/Mac (kad Apple Maps siūlytume tik ten, kur veikia natūraliai)
export function arApple() {
  if (typeof navigator === 'undefined') return false
  return /iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent || '')
}

export function navUrl(id, lat, lng) {
  switch (id) {
    case 'waze':
      return `https://www.waze.com/ul?ll=${lat},${lng}&navigate=yes`
    case 'apple':
      return `https://maps.apple.com/?daddr=${lat},${lng}&dirflg=d`
    case 'google':
    default:
      return `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`
  }
}

// Tiesioginė nuoroda į programėlę (ne per naršyklę). Tik ten, kur ji patikima.
function programosUrl(id, lat, lng) {
  if (id === 'waze') return `waze://?ll=${lat},${lng}&navigate=yes`
  return null
}

// Atidaro pasirinktą navigaciją į vietą.
//
// ⚠️ 2026-09-22: anksčiau buvo window.open(..., '_blank'). Įdiegtoje PWA
// (paleistoje iš pradžios ekrano) tai atsidaro atskirame naršyklės lange,
// ir perdavimas programėlei kartais nutrūksta — Waze atsidaro be maršruto.
// Dabar: pirma bandom tiesioginę programėlės nuorodą, o jei per 1,5 s niekas
// neįvyko — atsarginė https nuoroda.
export function atidarytiNavigacija(id, lat, lng) {
  const x = Number(lat)
  const y = Number(lng)
  if (!Number.isFinite(x) || !Number.isFinite(y)) return false

  const webUrl = navUrl(id, x, y)
  const appUrl = programosUrl(id, x, y)

  if (!appUrl) {
    window.location.href = webUrl
    return true
  }

  let perjungta = false
  const pazymeti = () => { perjungta = true }
  document.addEventListener('visibilitychange', pazymeti, { once: true })
  window.blur && window.addEventListener('blur', pazymeti, { once: true })

  setTimeout(() => {
    document.removeEventListener('visibilitychange', pazymeti)
    window.removeEventListener('blur', pazymeti)
    if (!perjungta && document.visibilityState === 'visible') {
      window.location.href = webUrl
    }
  }, 1500)

  window.location.href = appUrl
  return true
}
